import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ff50a428"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-sub-container left" }
const _hoisted_2 = { class: "header-sub-container center" }
const _hoisted_3 = ["data-testid"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "//dam.malt.com/rebranding2020/malt-logo/malt-red",
  height: "40",
  width: "140",
  alt: "Malt"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "header-sub-container right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_icon_button = _resolveComponent("joy-icon-button")!

  return (_openBlock(), _createElementBlock("header", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.showButtonPrevious)
        ? (_openBlock(), _createBlock(_component_joy_icon_button, {
            key: 0,
            icon: "arrow-left",
            class: "profile-creation-wizard__content-header-previous",
            "arial-label": _ctx.$msg('generic.navigation.button.prev'),
            title: _ctx.$msg('generic.navigation.button.prev'),
            "data-testid": _ctx.dataTestId('previous'),
            onClick: _ctx.handleClickOnPrevious
          }, null, 8, ["arial-label", "title", "data-testid", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "/",
        "data-testid": _ctx.dataTestId('home-page')
      }, _hoisted_5, 8, _hoisted_3)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _renderSlot(_ctx.$slots, "right", {}, undefined, true)
    ])
  ]))
}